import { render, staticRenderFns } from "./VoiceButton.vue?vue&type=template&id=03a5cb84&lang=pug&"
import script from "./VoiceButton.vue?vue&type=script&lang=js&"
export * from "./VoiceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports